<template>
  <div class="msg">
    <div class="msg-banner">
      <img src="@/assets/outSide/dp-top-bg.png" />
    </div>
    <div class="msg-first">
      <img src="@/assets/outSide/title.png" alt />
    </div>
    <div class="head-img">
      <img :src="msg.img | _headImg" alt />
    </div>
    <div class="msg-second">
      <p>
        <span>{{msg.name}}</span>
        <span>DONG PO DANG YUAN XINXI</span>
      </p>
      <p>我的承诺:</p>
      <p>{{msg.promise}}</p>
    </div>
    <div class="msg-third">
      <div class="msg-third-box">
        <div class="msg-third-box-left">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </div>
        <div class="msg-third-box-right">
          <img src="@/assets/outSide/wenzi.png" alt />
          <p>WO DE ZHI YUAN FU WU</p>
          <p>{{msg.service}}</p>
        </div>
      </div>
      <img class="posi" src="@/assets/outSide/flower.png" alt />
    </div>

    <div class="msg-four">
      <div class="msg-four-title">志愿服务展示</div>
      <div class="msg-four-box">
        <div class="tem" v-for="(data,i) in list" :key="i">
          <p>{{data.time}}</p>
          <p>{{data.headline}}</p>
          <img :src="data.photo | _headImg" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: {},
      list: [],
      id: 1
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getMsg();
    this.getList();
  },
  methods: {
    getMsg() {
      this.axios
        .get("/api/Main/Generate", {
          params: {
            id: this.id
          }
        })
        .then(e => {
          if (e.data.code === 0) {
            // console.log(e.data.msg)
            this.msg = e.data.msg;
          }
        });
    },
    getList() {
      this.axios
        .get("/api/Main/ShareMsg", {
          params: {
            id: this.id
          }
        })
        .then(e => {
          if (e.data.code === 0) {
            // console.log(e.data)
            this.list = e.data.msg;
          }
        });
    }
  },
  filters: {
    _headImg: value => {
      // console.log(value)
      if (value === undefined) return "";
      return value.indexOf("http") > -1
        ? value
        : "https://dpadmin.djplus.cn/Service/" + value;
    }
  }
};
</script>
<style lang='scss' scoped>
.msg {
  &-four {
    &-box {
      .tem {
        p {
          &:nth-child(1) {
            margin-top: -0.35rem;
          }
          &:nth-child(2) {
            padding: 0.2rem 0;
          }
        }
        img {
          width: 100%;
          border-radius: 0.08rem;
        }
        &:not(:last-child) {
          border-left: 0.01rem solid #10b77f;
        }
        &::before {
          position: absolute;
          content: "";
          width: 0.14rem;
          height: 0.14rem;
          background: rgba(12, 150, 104, 1);
          border-radius: 50%;
          top: 0;
          left: -0.07rem;
        }
        padding: 0.2rem;
        position: relative;
        padding-bottom: 0.4rem;
      }
      margin-top: 0.6rem;
    }
    &-title {
      font-weight: bold;
      z-index: 5;
      position: absolute;
      top: 0.2rem;
    }
    width: 94%;
    background: rgba($color: #fff, $alpha: 0.8);
    padding: 0.4rem;
    margin: 0 auto;
    margin-top: -2rem;
    position: relative;
  }
  &-third {
    &-box {
      &-left {
        li {
          width: 0.2rem;
          height: 0.2rem;
          background: #f9ba4e;
          border-radius: 50%;
          margin-top: 0.2rem;
        }
        margin-right: 0.2rem;
      }
      &-right {
        img {
          width: 38%;
        }
        p {
          &:nth-child(2) {
            font-size: 0.26rem;
            color: rgba($color: #fff, $alpha: 0.6);
            margin-top: -0.2rem;
          }
          &:nth-child(3) {
            font-weight: 0.3rem;
            padding-top: .15rem;
          }
        }

        background: linear-gradient(
          120deg,
          rgba(250, 183, 73, 1) 0%,
          rgba(253, 236, 85, 1) 100%
        );
        padding: 0.2rem;
        border-radius: 0.24rem;
        width: 100%;
        margin-top: .25rem;
      }
      display: flex;
      align-items: center;
      position: absolute;
      width: 100%;
    }
    .posi {
      width: 100%;
    }
    width: 94%;
    margin: 0 auto;
    position: relative;
  }
  &-second {
    p {
      &:nth-child(1) {
        span {
          &:nth-child(1) {
            font-size: 0.36rem;
            font-weight: bold;
            grid-row: 1 / 2;
          }
          &:nth-child(2) {
            color: rgba($color: #fff, $alpha: 0.6);
            font-size: 0.22rem;
            text-align: right;
            grid-row: 1 / 2;
          }
        }
        display: grid;
        align-items: center;
        line-height: 2;
      }
      &:nth-child(2) {
        font-size: 0.28rem;
        color: #666;
        margin-top: 0.08rem;
        margin-bottom: 0.1rem;
      }
      &:nth-child(3) {
        font-weight: bold;
      }
      margin-left: 2.5rem;
    }
    background: linear-gradient(
      120deg,
      rgba(250, 183, 73, 1) 0%,
      rgba(253, 236, 85, 1) 100%
    );
    border-radius: 0.24rem;
    padding: 0.2rem;
    width: 94%;
    margin: 0 auto;
    margin-top: 0.1rem;
  }
  &-first {
    img {
      width: 65%;
      padding: 0 0.2rem;
    }
    text-align: right;
    margin-top: -0.8rem;
    line-height: 0;
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  .head-img {
    img {
      width: 2.3rem;
      height: 3.2rem;
      border-radius: 0.08rem;
    }
    position: absolute;
    top: 2.2rem;
    left: 0.4rem;
    z-index: 5;
  }
  background: #f9f2e2;
  font-size: 0.3rem;
  min-height: 100vh;
}
</style>